import * as React from 'react'
import styled from '../theme/styled'

const Wrapper = styled.footer`
  background: ${({ theme }) => `${theme.color.textDark}`};
  padding: 15px 15px 15px 15px;
  flex-shrink: 0;
  text-align: center;
  font-family: "Gotham M","Gotham B",Sans-serif;
  color: ${({ theme }) => theme.color.white};
  display: flex;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.footer}`}) {
    flex-wrap: wrap;
    flex-direction: column;
  }
`

const CopyrightText = styled.div`
  margin: 15px 0;
  font-weight: bold;
`

const LinkList = styled.ul`
  display: flex;
  margin: 0;
  padding: 0;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.footer}`}) {
    flex-wrap: wrap;
    flex-direction: column;
  }
`

const ListLi = styled.li`
  border: 0;
  margin: 5px 0px;
  padding: 0px 20px;
  @media (min-width: ${({ theme }) => `${theme.breakpoint.footer}`}) {
    &.white-border {
      border-right: 1px solid #fff;
      border-left: 1px solid #fff;
    }
    margin: 15px 0px;
  }
`

const Link = styled.a`
  font-size: ${({ theme }) => theme.fontSize.medium};
  color:${({ theme }) => theme.color.white};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.color.textLight};
  }
`

class Footer extends React.PureComponent<{}> {
  public render() {
    const d = new Date()
    return (
      <Wrapper>
        <CopyrightText>
          Copyright Vaisala {d.getFullYear()}
        </CopyrightText>
        <LinkList>
          <ListLi>
            <Link href="https://www.vaisala.com/en/vaisala-policies#legal-notice">
              Legal Notice
          </Link>
          </ListLi>
          <ListLi className={'white-border'}>
            <Link href="https://www.vaisala.com/en/vaisala-policies#privacy-policy">
              Privacy Policy
          </Link>
          </ListLi>
          <ListLi>
            <Link href="https://www.vaisala.com/en/vaisala-policies#terms-and-conditions">
              Terms and Conditions
            </Link>
          </ListLi>
        </LinkList>
      </Wrapper>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.tsx